import React, { useRef } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import './Speakers.css';
import parse from "html-react-parser";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Speaker = ({ webpageData }) => {
  const { speakers, title } = webpageData?.speakersSection;
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  const carouselRef = useRef(); // for controlling carousel programmatically

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 992, min: 768 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1.5
    }
  };

  const renderSpeakerCard = (speaker, index) => (
    <div key={`speaker-${index}`} className="speaker-col">
      <div className="speaker-card">
        <div className="speaker-image-container">
          <img
            src={imgCDNURL + speaker.imageUrl}
            alt={`${speaker.name}`}
            className="speaker-image"
          />
        </div>
        <div className="speaker-info">
          <h3 className="speaker-name">{parse(speaker.name)}</h3>
          {speaker.title && <p className="speaker-organization">{parse(speaker.title)}</p>}
        </div>
      </div>
    </div>
  );

  return (
    <div className="speakers-section">
      <Container>
        <div className="speakers-container">
          {/* <h2 className="speakers-title">{title}<sup>*</sup></h2> */}
          <p className="speaker-text-pe">A special thank you to the exceptional speakers who gave their time and insights, enriching our discussions on the intersection of Ai, blockchain, and the future of business in America. Your expertise and forward-thinking ideas are what will drive innovation, guide future policies, and inspire the next wave of breakthroughs in these transformative fields.</p>
          {speakers.length > 4 ? (
            <div className="carousel-wrapper">
              <button className="carousel-arrow prev" aria-label="Previous" onClick={() => carouselRef.current?.previous()}>
              <span>❮</span></button>
              <Carousel
                ref={carouselRef}
                responsive={responsive}
                infinite
                autoPlay
                autoPlaySpeed={3000}
                showDots={false}
                arrows={false} // Disable default arrows
                keyBoardControl
                swipeable
                draggable
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {speakers.map(renderSpeakerCard)}
              </Carousel>

              <button className="carousel-arrow next" aria-label="Next" onClick={() => carouselRef.current?.next()}>
              <span>❯</span></button>
            </div>

            
          ) : (
            <Row className="speakers-grid">
              {speakers.map((speaker, index) => renderSpeakerCard(speaker, index))}
            </Row>
          )}
{/* <div className="speakers-grid-paragragh"><p>*Speakers are subject to change</p></div> */}
        </div>
      </Container>
     
    </div>
  );
};

export default Speaker;
